import { jsonGet, jsonPost } from "../api";

export const fetchWebsites = async () => jsonGet("websites");

export const fetchWebsiteByBaseUrl = async (baseUrl) =>
  jsonGet(`websites/${encodeURIComponent(baseUrl)}`);

export const fetchWebsiteById = async (id) => jsonGet(`websites/${id}`);

export const createWebsite = async (baseUrl) =>
  jsonPost("websites", { baseUrl });
